import { render, staticRenderFns } from "./RepairItemClassifyRuleMaintain.vue?vue&type=template&id=a0ce2fcc"
import script from "./RepairItemClassifyRuleMaintain.vue?vue&type=script&lang=js"
export * from "./RepairItemClassifyRuleMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports